import React from 'react';

const ShaderBackground = ({ theme }) => {
  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute w-full h-full object-cover"
      >
        <source src={theme.video.background} type="video/mp4" />
      </video>
      <div className={`absolute inset-0 ${theme.styles.overlay}`} />
    </div>
  );
};

export default ShaderBackground;